// Messagerie : miroir des DTOs exposés par `/api/conversations` (cf. backend
// Kms7Backend.API/DTOs/Response/ResponseConversationDto.cs).

/** Nature d'un fil, et donc qui y a sa place. */
export enum TypeConversation {
  /** Fil d'une course réunissant le client, le chauffeur affecté et le back-office. */
  CourseClient = 0,
  /** Fil d'une course entre le chauffeur affecté et le back-office, invisible du client. */
  CourseChauffeur = 1,
  /** Fil permanent entre un chauffeur et le back-office, hors de toute course. */
  SupportChauffeur = 2,
}

/** À quel titre un contact participe à un fil. Sert à l'affichage, pas au droit d'accès. */
export enum RoleConversation {
  Passager = 0,
  Demandeur = 1,
  Chauffeur = 2,
  Gestionnaire = 3,
}

export type ParticipantConversation = {
  idContact: number;
  role: RoleConversation;
  /** Marque-page de lecture du participant, null s'il n'a jamais ouvert le fil. */
  luJusquA: string | null;
  /** Vide si le compte a été supprimé depuis : le fil garde la participation, pas l'identité. */
  nom: string;
  prenom: string;
};

export type Message = {
  id: number;
  idConversation: number;
  idAuteurContact: number;
  auteurNom: string;
  auteurPrenom: string;
  contenu: string;
  /** ISO 8601 UTC. */
  envoyeLe: string;
};

export type Conversation = {
  id: number;
  type: TypeConversation;
  /** Identité naturelle du fil, ex. `course:42:client`. */
  cle: string;
  idCourse: number | null;
  idChauffeurSupport: number | null;
  /** Le fil n'accepte plus de message. */
  lectureSeule: boolean;
  ecritureFermeeLe: string | null;
  nombreNonLus: number;
  dernierMessage: Message | null;
  participants: ParticipantConversation[];
};

/** Page de messages et curseur de remontée du fil. */
export type PageMessages = {
  messages: Message[];
  /** À repasser en `avant` pour la page précédente, null en début de fil. */
  curseurSuivant: number | null;
};

/** Portée d'un fil à ouvrir : la cible est une course, ou un chauffeur pour le support. */
export type OuvertureConversation = {
  type: TypeConversation;
  idCible: number;
};
